import React, { useEffect, useState } from 'react';
import * as Styled from '@/components/AdvantageOfVf/Informing/Informing.styles';
import Text from '@/common/Text/Text';
import Image from 'next/legacy/image';
import { InfoCircle } from '@/icons';
import { getSessionStorage, imageLoader } from '@/utils';

const Informing = () => {
  const [channel, setChannel] = useState<string | null>(null);

  const handleClick = (url: string) => {
    window.location.href = url;
  };

  useEffect(() => {
    const channelValue = getSessionStorage('channel');
    setChannel(channelValue);
  }, []);

  const renderTextContent = () => (
    <>
      Başvurunuz esnasında paylaşacağınız GSM numarası, adres, ad-soyadı, T.C.
      Kimlik numarası, cinsiyet ve elektronik posta bilgileriniz, hizmet almak
      istediğiniz adreste mevcut altyapıya uygun Vodafone Net ürün ve
      kampanyalarının tarafınıza gösterilebilmesi, abonelik başvurunuzun
      tamamlanabilmesi için tarafınızla iletişime geçilebilmesi ve size doğru
      şekilde hitap edilebilmesi amaçlarıyla, bir sözleşmenin kurulması veya
      ifasıyla doğrudan doğruya ilgili olması kaydıyla sözleşmenin taraflarına
      ait kişisel verilerin işlenmesinin gerekli olması hukuki sebebine dayalı
      olarak, otomatik yollarla, Vodafone Net İletişim Hizmetleri AŞ tarafından
      işlenecek ve belirtilen amaçlarla KVKK&#39;nın &quot;Kişisel Verilerin
      Yurt Dışına Aktarılması&quot; başlıklı 9. maddesindeki kurallara uyularak
      ve gerekli teknik ve idari tedbirler alınarak, size sunduğumuz hizmet
      kalitesini ve hizmet sürekliliğini sağlayabileceğimiz yurt içi
      alternatiflerimiz olmaması nedeniyle, teknoloji alanındaki iletişim
      hizmetleri altyapısı sunan yurt dışında yerleşik ve sunucuları yurt
      dışında bulunan Whatsapp (Whatsapp Inc.) tarafından sağlanan /
      kullanımımıza sunulan programlarımıza ve/veya sistemlerimize; iletişim
      faaliyetlerinin yürütülmesi, iş faaliyetlerinin yürütülmesi ve denetimi,
      mal ve hizmet satış süreçlerinin yürütülmesi, müşteri memnuniyetine
      yönelik faaliyetlerin yürütülmesi, müşteri ilişkileri yönetimi
      süreçlerinin yürütülmesi, pazarlama faaliyetlerinin yürütülmesi, saklama
      ve arşiv faaliyetlerinin yürütülmesi, talep ve şikayetlerin takibi
      amaçlarıyla kaydedilebilecek ve dolayısıyla yurt dışına
      aktarılabilecektir. Kişisel Verilerin Korunması Kanunu kapsamında sahip
      olduğunuz haklarınız ve detaylar için
      {channel === ' app' ? (
        <Styled.Link>
          <span
            onClick={() =>
              handleClick(
                'https://www.vodafone.com.tr/VodafoneHakkinda/gizlilik-ve-guvenlik-politikalari?renderPlaces=content'
              )
            }
          >
            &nbsp; Gizlilik Politikasını
          </span>
        </Styled.Link>
      ) : (
        <Styled.Link
          target="_blank"
          href="https://www.vodafone.com.tr/VodafoneHakkinda/gizlilik-ve-guvenlik-politikalari"
        >
          &nbsp; Gizlilik Politikasını
        </Styled.Link>
      )}{' '}
      okuyunuz.
    </>
  );

  return (
    <Styled.Container>
      <Styled.InfoContainer>
        <Styled.IconContainer>
          <Image
            src={InfoCircle}
            alt="InfoCircle"
            layout="fixed"
            loader={imageLoader}
            height={20}
            width={20}
          />
          <Text fontSize={18} margin="0 0 0 2px">
            Yasal Bilgilendirme
          </Text>
        </Styled.IconContainer>
        <Styled.TextContainer>
          <Text fontSize={14} margin="0 0 0 20px" align="left">
            {renderTextContent()}
          </Text>
        </Styled.TextContainer>
      </Styled.InfoContainer>
    </Styled.Container>
  );
};

export default Informing;
